import { Badge, Button, Group } from '@mantine/core';
import { IconCalendarStats } from '@tabler/icons-react';
import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { getTravelOwnDayBalanceOptions } from '../model/TravelRequestQuery';
import { travelDayBalanceColor } from './TravelDayBalanceCommon';

export function TravelOwnDayBalanceChip() {
  const { t } = useTranslation();
  const { data } = useQuery(getTravelOwnDayBalanceOptions(new Date().getFullYear()));

  return (
    <Group gap="xs">
      <Button
        component={Link}
        to="/travel/days"
        variant="light"
        size="sm"
        leftSection={<IconCalendarStats size={16} />}
      >
        {t('travel.requests.dayBalance.link')}
      </Button>
      {data != null && (
        <Badge
          variant="light"
          color={travelDayBalanceColor(data.withPaperUsed, data.withPaperCap)}
        >
          {t('travel.requests.dayBalance.chip', {
            year: data.year,
            used: data.withPaperUsed,
            cap: data.withPaperCap,
          })}
        </Badge>
      )}
    </Group>
  );
}
